var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHidden = function SvgHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.708 9.042a2.002 2.002 0 1 1-2.742-2.743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 11.334a6.582 6.582 0 0 1-3.997 1.338 6.305 6.305 0 0 1-5.705-3.394 2.882 2.882 0 0 1 0-2.55c.552-1.1 1.432-2 2.519-2.578M13.621 9.426c.027-.05.062-.096.087-.148a2.882 2.882 0 0 0 0-2.55 6.305 6.305 0 0 0-5.705-3.393c-.15 0-.296.02-.444.03M14.006 13.339 2.666 2"
  })));
};
export { SvgHidden as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiN2QxZjZkNTAyYmIwNjZjODJjNDY5YjEyNWNkMzU5OGYuc3ZnIjs=";